import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";

import CreatableSelect from "react-select/creatable";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Swal from "sweetalert2";
import Toast from "../../utils/Toast";

import useManagers from "../../queries/user/getManagers.js";
import useSuperAdmins from "../../queries/user/getUsers.js";
import useCreateUser from "../../mutation/user/createUser";
import autoGenerate from "../../utils/autoGenerate";
import { AuthContext } from "../../utils/userProvider";
import {
  FormPageShell,
  FormPageCard,
  FormPageHeader,
  FormActions,
} from "../../components/ListPage";

const schema = yup.object().shape({
  username: yup.string().required("username is required"),
  password: yup.string().required("password is required"),
  email: yup.string().required("Email is required"),
  accessRole: yup.object().required("An access role must be selected."),
  manager: yup.string(),
  superadmin: yup.string(),
});

const NewUser = (props) => {
  const history = useHistory();

  const [managerRespose, setManagerResponse] = useManagers();
  const [superAdminResponse, setSuperAdminResponse] = useSuperAdmins();
  const { authState, setAuthState } = useContext(AuthContext);

  const [createResponse, setData] = useCreateUser();
  const tabAccessOptions = [
    { label: "City", value: "city" },
    { label: "Property", value: "property" },
    { label: "Room Types", value: "roomtypes" },
    { label: "Add-ons", value: "addons" },
    { label: "Agents", value: "agent" },
    { label: "Active Transactions", value: "transactions" },
    { label: "Expired Transactions", value: "expiredTransactions" },
    { label: "Promotions", value: "promotions" },
    { label: "Rate Nunbers", value: "rate-numbers" },
    { label: "Gifts", value: "gifts" },
    { label: "Credit Notes", value: "creditnote" },
    { label: "Stripe Fees", value: "stripefees" },
    { label: "Users", value: "users" },
    { label: "Pending Audits", value: "pending-audits" },
    { label: "Approved Audits", value: "approved-audits" },
    { label: "Rejected Audits", value: "rejected-audits" },
    { label: "System Settings", value: "system-setting" },
    { label: "Account Settings", value: "setting" },
  ];

  const [managerOptions, setManagerOptions] = useState([]);
  const [superAdminOptions, setSuperAdminOptions] = useState([]);
  const [selectedRole, setSelectedRole] = useState();
  const [defaultTabAccessValue, setDefaultTabAccess] = useState([]);

  const [accessRoleOptions, setAccessRoleOptions] = useState([
    { label: "Manager", value: "Manager" },
    { label: "Executive", value: "Executive" },
  ]);

  const accessRoleChange = (value) => {
    setValue("accessRole", value);
    setSelectedRole(value.value);
  };

  const managerChange = (value) => {
    setValue("manager", value.value);
  };

  const superAdminChange = (value) => {
    setValue("superadmin", value.value);
  };

  const { control, register, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    let tabAccess = [];
    for (var i = 0; i < tabAccessOptions.length; i++) {
      tabAccess.push(tabAccessOptions[i]);
    }
    setValue("tabAccess", tabAccess);
    setDefaultTabAccess(tabAccess);
  }, []);

  useEffect(() => {
    console.log(errors);
  }, [errors]);

  useEffect(() => {
    if (authState.role == "Executive") {
      history.push("/dashboard/roomtypes");
    }
    if (authState.role == "Manager") {
      setAccessRoleOptions([{ label: "Executive", value: "Executive" }]);
    }
  }, [authState]);

  useEffect(() => {
    if (managerRespose.data) {
      //setup options
      let data = managerRespose.data;
      let managerOptions = [];
      for (var i = 0; i < data.length; i++) {
        let manager = data[i];
        managerOptions.push({
          label: manager.email,
          value: manager.id,
        });
      }

      setManagerOptions(managerOptions);
    }
  }, [managerRespose]);

  useEffect(() => {
    if (superAdminResponse.data) {
      //setup options
      let data = superAdminResponse.data;
      let SuperAdminOptions = [];
      for (var i = 0; i < data.length; i++) {
        let SuperAdmin = data[i];
        if (SuperAdmin.accessRole == "SuperAdmin") {
          SuperAdminOptions.push({
            label: SuperAdmin.email,
            value: SuperAdmin.id,
          });
        }
      }
      setSuperAdminOptions(SuperAdminOptions);
    }
  }, [superAdminResponse]);

  const goBack = () => {
    window.location.href = "/dashboard/users";
  };

  const autoGeneratePassword = () => {
    setValue("password", autoGenerate(6));
  };

  const tabAccessChange = (value) => {
    setValue("tabAccess", value);
  };

  const onSubmit = (values) => {
    values.accessRole = values.accessRole.value;
    let tabAccess = [];
    if (values.tabAccess) {
      for (var i = 0; i < values.tabAccess.length; i++) {
        tabAccess.push(values.tabAccess[i].value);
      }
      values.tabAccess = tabAccess;
    }
    setData(values);
  };

  useEffect(() => {
    try {
      if (createResponse.data) {
        Toast.fire({
          icon: "success",
          title: "User created",
        });
        history.push("/dashboard/users");
      } else if (createResponse.error) {
        let data = createResponse.errorMessage.response.data;
        if (data) {
          let messageData = data.message;
          let message = messageData.message;

          if (message == "Dates Unavailable") {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "The time period for the Rate number overlaps with an existing rate number. Please change the time period.",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: message,
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: createResponse.error.message,
          });
        }
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message,
      });
    }
  }, [createResponse]);

  const fieldLabelSx = { fontSize: 16, fontWeight: "bold", mt: 2, mb: 1 };

  return (
    <FormPageShell>
      <Box
        component="form"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
      >
        <Stack spacing={2}>
          <FormPageCard>
            <FormPageHeader
              title="New User"
              onBack={goBack}
              subtitle="Please fill in the required fields."
            />
            <TextField
              name="username"
              margin="normal"
              fullWidth
              label="Username*"
              variant="outlined"
              inputRef={register}
              error={errors.name != null}
              helperText={errors.name != null ? errors.name.message : null}
              disabled={createResponse.loading}
            />
            <TextField
              name="email"
              margin="normal"
              fullWidth
              label="Email*"
              variant="outlined"
              inputRef={register}
              error={errors.name != null}
              helperText={errors.name != null ? errors.name.message : null}
              disabled={createResponse.loading}
            />
            <TextField
              name="password"
              margin="normal"
              fullWidth
              label="Password*"
              variant="outlined"
              inputRef={register}
              error={errors.name != null}
              helperText={errors.name != null ? errors.name.message : null}
              disabled={createResponse.loading}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="auto-generate-password"
                      onClick={autoGeneratePassword}
                    >
                      <CachedIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Typography sx={fieldLabelSx}>Tab Access</Typography>
            {tabAccessOptions.length > 0 &&
              defaultTabAccessValue.length > 0 && (
                <Box>
                  <Controller
                    name="tabAccess"
                    control={control}
                    defaultValue={
                      defaultTabAccessValue ? defaultTabAccessValue : null
                    }
                    render={({ ...props }) => {
                      return (
                        <CreatableSelect
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              borderColor: errors.tabAccess
                                ? "red"
                                : provided.borderColor,
                            }),
                          }}
                          isMulti
                          defaultValue={
                            defaultTabAccessValue
                              ? defaultTabAccessValue
                              : null
                          }
                          options={tabAccessOptions}
                          onChange={tabAccessChange}
                          disabled={createResponse.loading}
                        />
                      );
                    }}
                  />
                  {errors.tabAccess && (
                    <Box>{errors.tabAccess.message}</Box>
                  )}
                </Box>
              )}
            {accessRoleOptions.length > 0 && (
              <Box>
                <Typography sx={fieldLabelSx}>Access Role</Typography>
                <Controller
                  name="accessRole"
                  control={control}
                  render={({ ...props }) => {
                    return (
                      <CreatableSelect
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            borderColor: errors.accessRole
                              ? "red"
                              : provided.borderColor,
                          }),
                        }}
                        options={accessRoleOptions}
                        onChange={accessRoleChange}
                        disabled={createResponse.loading}
                      />
                    );
                  }}
                />
                {errors.accessRole && (
                  <Box>{errors.accessRole.message}</Box>
                )}
              </Box>
            )}
            {selectedRole == "Executive" && authState.role == "SuperAdmin" && (
              <Box>
                <Typography sx={fieldLabelSx}>Supervising Manager</Typography>
                <Controller
                  name="manager"
                  control={control}
                  render={({ ...props }) => {
                    return (
                      <CreatableSelect
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            borderColor: errors.room_types
                              ? "red"
                              : provided.borderColor,
                          }),
                        }}
                        options={managerOptions}
                        onChange={managerChange}
                        disabled={createResponse.loading}
                      />
                    );
                  }}
                />
                {errors.manager && <Box>{errors.manager.message}</Box>}
              </Box>
            )}
            {selectedRole == "Executive" && authState.role == "Manager" && (
              <Box>
                <Typography sx={fieldLabelSx}>
                  Supervising Super Admin
                </Typography>
                <Controller
                  name="superadmin"
                  control={control}
                  render={({ ...props }) => {
                    return (
                      <CreatableSelect
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            borderColor: errors.room_types
                              ? "red"
                              : provided.borderColor,
                          }),
                        }}
                        options={superAdminOptions}
                        onChange={superAdminChange}
                        disabled={createResponse.loading}
                      />
                    );
                  }}
                />
                {errors.properties && (
                  <Box>{errors.properties.message}</Box>
                )}
              </Box>
            )}
          </FormPageCard>
          <FormPageCard>
            <FormActions>
              <Button
                type="submit"
                size="large"
                variant="contained"
                color="primary"
                disabled={createResponse.loading}
              >
                Submit
              </Button>
            </FormActions>
          </FormPageCard>
        </Stack>
      </Box>
    </FormPageShell>
  );
};

export default NewUser;
